import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Checkout/CheckoutButton/checkoutButton.container"
    ).then((module) => ({ default: module.CheckoutButton }))
);
